import '~/assets/scss/support-page.scss'
import '~/js/modules/tabs';

const quikRequest = document.querySelector('.js-support-block');
if (quikRequest) {

    const inputSelect = quikRequest.querySelector('.js-select select');
    if (inputSelect) {
        inputSelect.onchange = () => {
            if (inputSelect.value) {
                inputSelect.parentElement.classList.remove(`invalid`);
                inputSelect.parentElement.setAttribute('data-invalid', '');
            } else {
                inputSelect.parentElement.classList.add(`invalid`);
                inputSelect.parentElement.setAttribute('data-invalid', 'Выберите вариант из выпадающего списка');
            }
        };
    }

    //по умолчанию должно быть js-input чтобы активировалась маска, но для скрытых по умолчанию полей не должно быть обязательным
    const corpoFields = quikRequest.querySelectorAll('.js-corpo-field');
    corpoFields.forEach((field) => {
        field.classList.remove('js-input');
    })

    //проверяем размер файла, не больше 5мб
    const fileInputs = [];
    const fileInputService = document.getElementById('fileservice');

    if (fileInputService)
        fileInputs.push(fileInputService);

    fileInputs.forEach((fileInput) => {
        const fileInputField = fileInput.parentElement;
        const fileCountLabel = fileInputField.querySelector('.js-file-count');
        const fileCountLabelDefault = fileCountLabel.innerHTML;
        const fileAttentionLabel = fileInputField.parentElement.querySelector('.js-file-info');
        const confirmSizeLimitWindow = fileInputField.parentElement.querySelector('.confirm-sizelimit');
        const fileInfoList = fileInputField.parentElement.querySelector('.js-files-list');
        let fileList = [];

        fileInput.onclick = function () {
            let $this = this;
            fileList = $this.files
        }

        fileInput.onchange = function () {
            let $this = this;
            let isSizeOverLimit = false;
            let isFileCountOverLimit = false;
            let newFileList = new DataTransfer();

            for (let i = 0; i < fileList.length; i++) {
                newFileList.items.add(fileList[i]);
            }
            if(newFileList.files.length < 5) {
                for (let i = 0; i < $this.files.length; i++) {
                    if(newFileList.files.length < 5) {
                        if ($this.files[i].size < 5242880) { //не больше 5мбайт
                            newFileList.items.add($this.files[i]);
                        }
                        else {
                            isSizeOverLimit = true;
                        }
                    }
                    else {
                        isFileCountOverLimit = true;
                        break;
                    }
                }
            }
            $this.files = newFileList.files;

            fileInputField.classList.remove('invalid');
            fileInput.setAttribute('data-value', '');

            //кнопка очистки списка загружаемых файлов
            let deleteBtn = fileInputField.parentElement.querySelector('.js-delete-files');
            deleteBtn.innerHTML = "";
            if (isSizeOverLimit || isFileCountOverLimit) {
                fileAttentionLabel.classList.add('invalid');
                if (confirmSizeLimitWindow) {
                    confirmSizeLimitWindow.classList.add('active');
                }
            } else {
                fileAttentionLabel.classList.remove('invalid');
                fileInputField.classList.remove('invalid');
                if (confirmSizeLimitWindow) {
                    confirmSizeLimitWindow.classList.remove('active');
                }
            }
            fileInfoList.innerHTML = ""
            for (let i = 0; i < $this.files.length; i++) {
                const fileinfo = document.createElement('div');
                const filename = document.createElement('span');
                const filedel = document.createElement('a');
                filedel.innerHTML = '<svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">' +
                '<path d="M15.4549 6.34375H4.54688V18.0497H15.4549V6.34375ZM14.2549 16.8497H5.74687V7.54375H14.2549V16.8497Z" fill="#75808F"/>' +
                '<path d="M3.08594 5.07819H16.9179V3.87819H12.6619V1.9502H7.34194V3.87819H3.08594V5.07819ZM8.54194 3.1502H11.4619V3.87819H8.54194V3.1502Z" fill="#75808F"/>' +
                '<path d="M8.59844 9.40186H7.39844V14.8579H8.59844V9.40186Z" fill="#75808F"/>' +
                '<path d="M12.5984 9.40186H11.3984V14.8579H12.5984V9.40186Z" fill="#75808F"/>' +
                '</svg>'
                filename.innerHTML = $this.files[i].name
                filedel.setAttribute('data-index',i)
                fileInfoList.appendChild(fileinfo)
                fileinfo.appendChild(filename)
                fileinfo.appendChild(filedel)
            }
            fileInfoList.onclick = function(e) {
                const tempFileList = new DataTransfer()
                const fileindex = e.target.closest('a').dataset.index;
                if (e.target.closest('a')) {
                    for (let i = 0; i < $this.files.length; i++) {
                        if(i != fileindex) {
                            tempFileList.items.add($this.files[i]);
                        }
                    }
                    $this.files = tempFileList.files;
                    e.target.closest('a').parentElement.remove()
                }
            };

            if (fileCountLabel && $this.value) {
                deleteBtn.innerHTML = "Очистить";

                deleteBtn.onclick = function () {
                    $this.value = "";
                    fileInfoList.innerHTML = ""
                    deleteBtn.innerHTML = "";
                    fileInputField.classList.remove('invalid');
                    fileInput.setAttribute('data-value', '');
                    fileCountLabel.innerHTML = fileCountLabelDefault;
                }
            }
        };
        if (confirmSizeLimitWindow) {
            confirmSizeLimitWindow.addEventListener('click', function (e) {
                confirmSizeLimitWindow.classList.remove('active');
                fileAttentionLabel.classList.remove('invalid');
            })
        }
    })
    const comment = document.getElementById('comment');
    const commentCounter = document.querySelector('.counter-comment__current');
    if (comment) {
        comment.oninput = () => {
            const length = comment.value.length
            commentCounter.textContent = length
            comment.style.height = 'auto';
            comment.style.height = (comment.scrollHeight) + 'px';
        };
    }
    const forms = quikRequest.querySelectorAll('form');

    forms.forEach((item) => {
        const clientTypeInputs = item.querySelectorAll('input[name=client]');
        const corpoField = item.querySelector('.js-corpo-field');
        const submitButton = item.querySelector('.js-submit-form');
        submitButton.onclick = () => {
            const spinner = document.querySelector('.spinner-box');
            if(spinner) {
                spinner.classList.add('active')
            }
        }
        //Formit не позволяет не проверить скрытое поле, поэтому поле название организации приходится переименовывать для правильной проверки
        const orgId = document.getElementById('orgname');
        if (clientTypeInputs) {
            clientTypeInputs.forEach((input) => {
                input.addEventListener('change', function (e) {
                    corpoField.classList.toggle('hidden');
                    if (input.value == 2) { //Если представитель организации
                        orgId.name = 'orgname';
                        corpoField.classList.add('js-input');
                    } else {
                        orgId.name = 'hidden_orgname';
                        corpoField.classList.remove('js-input');
                    }
                })
            })
        }
        item.addEventListener("submit", function (e) {
            //после попытки отправки формы скроллим на нужный блок, если он есть
            quikRequest.scrollIntoView({
                block: "start",
                behavior: "smooth"
            });

            if (inputSelect && !inputSelect.value) {

                inputSelect.parentElement.classList.add(`invalid`);
                inputSelect.parentElement.setAttribute('data-invalid', 'Выберите вариант из выпадающего списка')
            }
        })
    })
}
